<!-- logged in -->
<ng-container *ngIf="isLoggedIn$; else notLoggedIn">
  <router-outlet></router-outlet>
</ng-container>

<!-- not logged in -->
<ng-template #notLoggedIn>
  <router-outlet></router-outlet>
</ng-template>

<!-- ngx-ui-loader -->

<div style="position: relative">
  <!-- the position of the parent container must be set to relative -->
  <ngx-ui-loader></ngx-ui-loader>
</div>
